import {
  AddRoundLight,
  ChooseRow,
  CloseRoundLight,
  DoneLight,
  EditLightBig,
  SettingLineLight,
  TrashLight,
} from '@repo/go-icons';
import { Button, Tooltip } from '@repo/go-ui';
import { observer } from 'mobx-react-lite';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { IconButton } from '../../../shared/components/IconButton/IconButton';
import { Toolbar, ToolbarItem, ToolbarSeparator } from '../../components/Toolbar/Toolbar';

type Props = {
  isEditModeActive: boolean;
  onEnterEditMode: () => void;
  onAddRow: () => void;
  onDelete: () => void;
  onChooseRow: () => void;
  onSettingOpen: () => void;
  save: () => void;
  cancel: () => void;
  deleteDisabled?: boolean;
  leftBlockElement?: ReactNode;
};

export const RecommendationsToolbar = observer(function RecommendationsToolbar({
  isEditModeActive,
  onEnterEditMode,
  onAddRow,
  onDelete,
  onChooseRow,
  onSettingOpen,
  save,
  cancel,
  deleteDisabled,
  leftBlockElement,
}: Props) {
  const { t } = useTranslation();

  return (
    <Toolbar>
      {leftBlockElement && <ToolbarItem>{leftBlockElement}</ToolbarItem>}
      <Tooltip placement="left" title={t('alertsRecommendations:tableSettings')} delay={400}>
        <ToolbarItem toRight>
          <IconButton icon={<SettingLineLight />} onClick={onSettingOpen} />
        </ToolbarItem>
      </Tooltip>
      <ToolbarSeparator />
      {!isEditModeActive && (
        <ToolbarItem>
          <Button icon={<EditLightBig />} onClick={onEnterEditMode} />
        </ToolbarItem>
      )}
      {isEditModeActive && (
        <>
          <ToolbarItem>
            <Button icon={<AddRoundLight />} onClick={onAddRow}>
              {t('alertsRecommendations:addRow')}
            </Button>
          </ToolbarItem>
          <ToolbarItem>
            <Button variant="danger" icon={<TrashLight />} onClick={onDelete} disabled={deleteDisabled} />
          </ToolbarItem>
          <ToolbarItem>
            <Tooltip title={t('alertsRecommendations:actionsBar.save')} delay={400}>
              <div>
                <Button icon={<DoneLight />} variant="success" onClick={save} />
              </div>
            </Tooltip>
          </ToolbarItem>
          <ToolbarItem>
            <Tooltip title={t('alertsRecommendations:actionsBar.cancelChanges')} delay={400}>
              <div>
                <Button icon={<CloseRoundLight />} variant="danger" onClick={cancel} />
              </div>
            </Tooltip>
          </ToolbarItem>
        </>
      )}
      <ToolbarItem>
        <Button icon={<ChooseRow />} onClick={onChooseRow} />
      </ToolbarItem>
    </Toolbar>
  );
});
